import Route from "@ember/routing/route"

export default class IndexRoute extends Route {
  beforeModel() {
    // The index route only appears in local dev (normally, Cloudflare directs it to the marketing site).
    // Redirect to user.sign to save a click.
    this.replaceWith("user.sign")
  }
}
